import { SettingsLayout } from '@/components/features/settings/SettingsLayout';

export function SettingsPage() {
  return (
    <div className='flex h-full flex-col overflow-hidden'>
      {/* Header. Below `md` the phone screens carry their own
          (`SettingsPhone`): a page title over a list, or "‹ Settings" over a
          section - not this one stacked above either. */}
      <div className='mx-auto hidden w-full max-w-7xl flex-shrink-0 px-4 pb-6 pt-8 sm:px-6 md:block lg:px-8'>
        <h1 className='mb-2 text-3xl font-bold text-foreground'>Settings</h1>
        <p className='text-muted-foreground'>
          Manage your account, preferences, and learning experience.
        </p>
      </div>

      <div className='mx-auto min-h-0 w-full max-w-7xl flex-1 px-4 pb-0 sm:px-6 md:pb-8 lg:px-8'>
        <SettingsLayout />
      </div>
    </div>
  );
}
